import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { encryptMessage, generateRequestId, showNotification } from '../../../../../util/utility';
import { loginUser } from '../../../../App/AppActions';
import { handleValidationLogin } from '../../../../../util/loginValidations';
import { connect } from 'react-redux';
import GoogleSignIn from './GoogleSignIn';
import callApi from '../../../../../util/apiCaller';
import { random } from 'lodash';
import styled from 'styled-components';
import { Grid } from '@mui/material';

const FormInput = styled('input')`
    padding: 16px 12px;
    margin-bottom: 25px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: none;
    outline: none;
    border: none;
    color: #000000;
    font-size: 12px;
    font-weight: 500;
    border-radius: 6px;
    background-color: #f9f9f9;
    border-color: ${(props) => (props.errorBorder ? '#CE121D !important' : 'none')};
    &:focus,
    &:valid {
        border: 0.5px solid #4c8dff;
        background-color: #ffffff;
    }
    &:-webkit-autofill + label {
        top: -15px;
        left: 0;
        font-size: 10px;
        color: #8d8d8d;
        font-weight: 300;
    }
    &:focus ~ label {
        top: -15px;
        left: 0;
        font-size: 10px;
        color: #8d8d8d;
        font-weight: 300;
    }
    &:valid ~ label {
        top: -15px;
        left: 0;
        font-size: 10px;
        color: #8d8d8d;
        font-weight: 300;
    }
    &:disabled {
        background-color: #f8fff8;
    }
`;
const FormLabel = styled('label')`
    position: absolute;
    pointer-events: none;
    left: 10px;
    transition: 0.5s;
    top: ${(props) => (props.toDisableOrNot || props.compName ? '-15px' : '16px')};
    font-size: ${(props) => (props.toDisableOrNot || props.compName ? '12px' : '14px')};
    font-weight: 300;
    color: ${(props) => (props.toDisableOrNot || props.compName ? '#414141' : '#C3C3C3')};
    transition: 0.5s;
    margin-bottom: 0px;
`;

class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true,
            isCapsOn: false,
            user: {
                emailId: '',
                password: '',
            },
        };
        this.emailRef = createRef();
        this.pswdRef = createRef();
    }
    checkAutofill() {
        if (this.emailRef !== null && this.pswdRef !== null) {
            this.setState({ disabled: false });
        }
    }

    // toDisable = () => {
    //     const {emailId} = this.state.user;
    //     if (emailId.trim()) {
    //         return false
    //     }
    //     return true
    // }

    handleChange = (keyName, keyValue) => {
        // const isDisabled = this.toDisable();
        // if (this.state.disabled !== isDisabled) {
        //     this.setState({ disabled: isDisabled })
        // }
        let user = this.state.user;
        if (keyName === 'emailId') {
            keyValue = keyValue.toLowerCase();
        }
        user[keyName] = keyValue;
        this.setState({
            user: user,
        });
    };

    componentDidMount() {
        // console.log(this.pswdRef);
        // console.log(this.emailRef);
        this.checkAutofill();

        // Check for referrerEmail in URL parameters
        const searchParams = new URLSearchParams(this.props.location.search);
        const referrerEmail = searchParams.get('referrerEmail');
        if (referrerEmail) {
            this.handleChange('emailId', referrerEmail);
        }
    }

    handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }
        let payload = {
            requestId: generateRequestId(),
            isCapsOn: this.state.isCapsOn,
            workspaceRoute: false,
            incomingQuery: localStorage.getItem('incomingQueryLogin') ?? '',
            user: {
                ...this.state.user,
                userType: 'Investee',
            },
        };
        const check = handleValidationLogin(payload.user);
        if (check.isValid) {
            payload.user.password = encryptMessage(payload.user.password);
            this.props.dispatch(loginUser(payload));
        } else {
            showNotification('error', check.message);
        }
    };
    handleOTP = (e) => {
        if (e) {
            e.preventDefault();
        }
        let user = { ...this.state.user };
        const check = handleValidationLogin(user, true);
        if (check.isValid) {
            callApi(
                '/mfa/generateOtp',
                'POST',
                {
                    ...{
                        user: { emailId: this.state.user.emailId, userType: 'Investee' },
                        requestId: generateRequestId(),
                    },
                },
                {},
                'true',
            ).then((res) => {
                if (res.responseData.responseCode === 20) {
                    showNotification('success', res.responseData.responseMessage);
                    this.props.navigate('/otp-screen', { state: { user: this.state.user } });
                } else {
                    const message = res.responseData?.responseMessage
                        ? res.responseData.responseMessage
                        : 'Some Error Occurred';
                    showNotification('error', message);
                    this.props.navigate('/');
                }
            });
        } else {
            showNotification('error', check.message);
        }
    };

    render() {
        return (
            <>
                <Grid
                    item
                    xs={12}
                    md={12}
                    lg={4}
                    className="loginformMobile"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 99,
                        backgroundColor: '#fff',
                        borderRadius: {
                            xs: '43px 43px 0 0',
                            lg: '43px 0 0 0',
                        },
                        width: '100%',
                    }}
                >
                    <section id="inner-wrapper">
                        <article style={{ width: '100%' }}>
                            <div>
                                <h3
                                    className="welcomeLoginTitle"
                                    style={{
                                        fontFamily: 'gilroy-semibold',
                                        fontSize: '24px',
                                        lineHeight: '29px',
                                    }}
                                >
                                    Welcome to Recur Club
                                </h3>
                                <form>
                                    <div className="form-group mb-4" style={{ paddingTop: '15px' }}>
                                        <div className="input-group">
                                            {/* <span className="input-group-addon form-icons"><i
                                                className="fa fa-envelope"> </i></span> */}
                                            <FormInput
                                                ref={this.emailRef}
                                                required
                                                id="email"
                                                value={this.state.user.emailId}
                                                onChange={(e) =>
                                                    this.handleChange('emailId', e.target.value)
                                                }
                                                type="email"
                                                className="loginInput form-control"
                                            ></FormInput>
                                            <FormLabel
                                                toDisableOrNot={this.state.user.emailId}
                                                htmlFor="email"
                                            >
                                                Email
                                            </FormLabel>
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 ">
                                        <div className="input-group">
                                            {/* <span className="input-group-addon form-icons"><i className="fa fa-key"> </i></span> */}
                                            <FormInput
                                                ref={this.pswdRef}
                                                required
                                                id="pswd"
                                                value={this.state.user.password}
                                                onChange={(e) =>
                                                    this.handleChange('password', e.target.value)
                                                }
                                                onKeyUp={(e) => {
                                                    this.setState({
                                                        isCapsOn: e.getModifierState('CapsLock'),
                                                    });
                                                }}
                                                type="password"
                                                className="loginInput form-control"
                                                style={{ borderRadius: '4px' }}
                                            />
                                            <FormLabel
                                                toDisableOrNot={this.state.user.password}
                                                htmlFor="pswd"
                                            >
                                                Enter Password
                                            </FormLabel>
                                        </div>
                                    </div>
                                    {this.state.isCapsOn && (
                                        <div
                                            className="clr23 fs9"
                                            style={{
                                                marginTop: '-5px',
                                                marginLeft: '2px',
                                                lineHeight: 1.1,
                                            }}
                                        >
                                            Your CapsLock is on
                                        </div>
                                    )}
                                    <div className="res-investee-login d-flex justify-content-between align-items-center pt-3">
                                        <button
                                            onClick={this.handleSubmit}
                                            disabled={this.props.isLoggingIn}
                                            className="btn btn-primary btn-block button login-btn"
                                        >
                                            {this.props.isLoggingIn ? 'Logging' : 'Login'}
                                        </button>
                                        <button
                                            // disabled={this.state.disabled}
                                            onClick={this.handleOTP}
                                            className="btn btn-primary button login-btn-1 ml-3"
                                        >
                                            Login with OTP
                                        </button>
                                    </div>
                                </form>
                                {/* google sign in button */}
                                <div className="mt-4">
                                    <GoogleSignIn {...this.props} logIN={true} />
                                </div>

                                <div className="dont-have-acc ">
                                    <b>Don't have an account?</b>{' '}
                                    <Link
                                        className="remove-decor blue-color-onhover investee-login-signup"
                                        to="/signup"
                                        style={{
                                            color: '#2F8FFF',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Signup
                                    </Link>
                                </div>
                                <Link to="/forgot-password" className="remove-decor">
                                    <div style={{ cursor: 'pointer' }}>
                                        <div className="forgot-login blue-color-onhover investee-fp mt-3">
                                            Forgot password?{' '}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </article>
                    </section>
                </Grid>
            </>
        );
    }
}

export default connect(null)(LoginForm);
